export enum QualityEvents {
  VALIDATION_SET_OPENED = "quality_validation_set_opened",
  VALIDATION_SET_CREATED = "quality_validation_set_created",
  VALIDATED = "quality_validated",
  QA_SCORE_VIEWED = "quality_qa_score_viewed",
  EVALUATION_STARTED = "quality_evaluation_started",
  EVALUATION_COMPLETED = "quality_evaluation_completed",
  FEEDBACK_SUBMITTED = "quality_feedback_submitted",
  SCORE_UPDATED = "quality_score_updated",
  COMMENT_ADDED = "quality_comment_added",
  TRACKER_VIEWED = "quality_tracker_viewed",
  AUDIT_PERFORMED = "quality_audit_performed",
  VALIDATION_SET_ACTION = "quality_validation_set_action",
}